import React from "react";
import data from "../assets/data/data.json";
import Card from "../components/Card";
function Home() {
  return (<>
    <div className="p-2 pb-10 m-2 rounded-lg shadow-lg bg-violet-500 dark:bg-violet-950 dark:bg-opacity-40 h-full">
      <div className="grid grid-flow-row grid-rows-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 place-items-center gap-4 sm:gap-8 md:gap-12 lg:gap-16 xl:gap-20 m-4 sm:m-8 md:m-12 lg:m-16 xl:m-20">
        {data.map((item, index) => {
          return (
            <Card
              key={index}
              source={item.img}
              title={item.title}
              summary={item.description}
              url={item.url}
              repo={item.repo}
            />
          );
        })}
      </div>
      </div>
      </>);
}

export default Home;
